<template lang="pug">
.news_detail
  //- jumbotron
    =============================================
  banner(:background="backgroundImage", :title="title")
  //- container
    =============================================
  .py-5.bg-light
    .container
      .row
        .col-md-8
          h2.mb-3 {{ newsDetail.title }}
          .p-4
            img.w-100(v-if="newsDetail.photo", :src="newsDetail.photo.image")
          .news_detail_html.py-3
            p(v-html="newsDetail.content") 
          a.btn.btn-outline-secondary.btn-sm.py-0(
            v-for="(tag, index) in newsDetail.tags",
            :key="index"
          ) {{ tag }}
            | &#32;
          .share.py-2.my-4.d-flex.align-items-center.justify-content-end
            strong.text-primary.mr-2 share
            ShareNetwork(
              network="Twitter",
              :url="url",
              :title="newsDetail.title",
              @click.native="shareClick"
            )
              .share-icon.twitter.mr-1
                font-awesome-icon(:icon="['fab', 'twitter']")
            ShareNetwork(
              network="LinkedIn",
              :url="url",
              :title="newsDetail.title",
              @click.native="shareClick"
            )
              .share-icon.linkedin.mr-1
                font-awesome-icon(:icon="['fab', 'linkedin-in']") 
            ShareNetwork(
              network="Line",
              :url="url",
              :title="newsDetail.title",
              @click.native="shareClick"
            )
              .share-icon.line
                font-awesome-icon(:icon="['fab', 'line']") 
          h5.mb-4 {{ moreTitle }}
          .row
            announcement-item(
              v-for="(announcementItem, index) in moreList",
              :key="index",
              :item="announcementItem",
              @click.native="toAnotherTpeDetail(announcementItem.id)"
            )
          form.p-4.bg-white.my-5
            h4.mb-4 contact
            .form-row
              .form-group.col-md-6
                input.form-control.rounded-0(
                  type="text",
                  placeholder="First name"
                )
              .form-group.col-md-6
                input.form-control.rounded-0(
                  type="text",
                  placeholder="Last name"
                )
            .form-row
              .form-group.col-md-6
                input.form-control.rounded-0(type="text", placeholder="E-mail")
              .form-group.col-md-6
                select#LocationSelect.form-control.rounded-0
                  option Location
                  option 2
                  option 3
                  option 4
                  option 5
            .form-group
              textarea#exampleFormControlTextarea1.form-control.rounded-0(
                placeholder="Welcome to messege gadget, let us know if you have any question :",
                rows="3"
              )
            button.btn.btn-primary.rounded-0.btn-block(type="submit") leave messege
        .col-md-4
          h4 Most Viewed
          ul.most-list.mb-3
            most-item(
              v-for="(mostViewdItem, index) in newsDetail.most_viewed",
              :key="index",
              :item="mostViewdItem",
              @click.native="toDetail(mostViewdItem.id)"
            )
          h4 Most Related
          ul.most-list
            most-item(
              v-for="(mostRelatedItem, index) in newsDetail.most_related",
              :key="index",
              :item="mostRelatedItem",
              @click.native="toDetail(mostRelatedItem.id)"
            )
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
</template>

<script>
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import Banner from "@/components/news_detail/Banner";
import MostItem from "@/components/news_detail/MostItem";
import AnnouncementItem from "@/components/news_detail/AnnouncementItem";
import {
  getNewsInformation,
  getAnnouncementById,
  getPressReleaseById,
  getEventHeadlineById,
  announcementShare,
  eventHeadlineShare,
  pressReleaseShare,
} from "@/api/news";

export default {
  name: "NewsDetail",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  components: {
    "custom-footer": Footer,
    FloatTop,
    FloatActions,
    Banner,
    MostItem,
    AnnouncementItem,
  },
  data() {
    return {
      newsInformation: {},

      title: "",
      backgroundImage: "",

      newsDetail: {
        title: "",
      },

      moreTitle: "",
      moreList: [],

      url: "",

      banner: {
        background:
          "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fGJ1c2luZXNzfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80",
      },

      metaData: {
        title: "",
      },
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
    this.getNewsInformation();
    this.url = window.location.href;
  },
  methods: {
    initialLanguage() {
      this.checkType();
    },
    shareClick() {
      if ("announcement" == this.$route.query.type) {
        announcementShare(this.$route.query.id).then(() => {});
      } else if ("press_release" == this.$route.query.type) {
        pressReleaseShare(this.$route.query.id).then(() => {});
      } else if ("event_headline" == this.$route.query.type) {
        eventHeadlineShare(this.$route.query.id).then(() => {});
      }
    },
    getNewsInformation() {
      getNewsInformation().then((response) => {
        this.newsInformation = response.data;

        if ("announcement" == this.$route.query.type) {
          this.backgroundImage = this.newsInformation.announcement_cover
            ? this.newsInformation.announcement_cover.image
            : null;
        } else if ("press_release" == this.$route.query.type) {
          this.backgroundImage = this.newsInformation.press_release_cover
            ? this.newsInformation.press_release_cover.image
            : null;
        } else if ("event_headline" == this.$route.query.type) {
          this.backgroundImage = this.newsInformation.event_headline_cover
            ? this.newsInformation.event_headline_cover.image
            : null;
        }
      });
    },
    getAnnouncementById() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getAnnouncementById(temp, this.$route.query.id).then((response) => {
        this.newsDetail = response.data;

        this.metaData.title = this.newsDetail.title;

        this.moreList = response.data.press_releases;
      });
    },
    getPressReleaseById() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getPressReleaseById(temp, this.$route.query.id).then((response) => {
        this.newsDetail = response.data;

        this.metaData.title = this.newsDetail.title;

        this.moreList = response.data.announcements;
      });
    },
    getEventHeadlineById() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getEventHeadlineById(temp, this.$route.query.id).then((response) => {
        this.newsDetail = response.data;

        this.metaData.title = this.newsDetail.title;

        this.moreList = response.data.announcements;
      });
    },
    checkType() {
      if ("announcement" == this.$route.query.type) {
        this.title = "Announcement";
        this.moreTitle = "News";
        this.getAnnouncementById();
      } else if ("press_release" == this.$route.query.type) {
        this.title = "News";
        this.moreTitle = "Announcement";
        this.getPressReleaseById();
      } else if ("event_headline" == this.$route.query.type) {
        this.title = "Events & Headlines";
        this.moreTitle = "Announcement";
        this.getEventHeadlineById();
      }
    },
    toDetail(id) {
      this.$router.push({
        name: "NewsDetail",
        query: {
          type: this.$route.query.type,
          id: id,
        },
      });
      this.checkType();
    },
    toAnotherTpeDetail(id) {
      let type;
      if ("announcement" == this.$route.query.type) {
        type = "press_release";
      } else if ("press_release" == this.$route.query.type) {
        type = "announcement";
      } else if ("event_headline" == this.$route.query.type) {
        type = "announcement";
      }

      this.$router.push({
        name: "NewsDetail",
        query: {
          type: type,
          id: id,
        },
      });
      this.checkType();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .news_detail_html {
  strong {
    font-weight: 600;
  }
}

.btn-outline-secondary {
  margin-right: 3px;
  color: #6c757d;
  border-color: #6c757d;

  &:hover {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
  }
}

.most-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>
